const slug = (label: string): string =>
  label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

export const homeTestIds = {
  // ── Legacy HomePage (unused but kept for coverage) ─────────────────────────
  page: 'home-page',
  heading: 'home-heading',
  subtitle: 'home-subtitle',
  statsGrid: 'home-stats-grid',
  statsLoading: 'home-stats-loading-message',
  statsEmpty: 'home-stats-empty-message',
  statCard: (label: string) => `home-stat-${slug(label)}-card` as const,
  statValue: (label: string) => `home-stat-${slug(label)}-value` as const,
  statLabel: (label: string) => `home-stat-${slug(label)}-label` as const,
  activitySection: 'home-activity-section',
  activityList: 'home-activity-list',
  activityEmpty: 'home-activity-empty-message',
  activityItem: (id: number | string) => `home-activity-item-${id}` as const,
  quickActionsSection: 'home-quick-actions-section',
  actionButton: (label: string) => `home-action-${slug(label)}-button` as const,

  // ── CommandCenter (the real homepage mounted at "/") ───────────────────────
  commandCenter: 'home-command-center',
  commandCenterLoading: 'home-command-center-loading',

  // Greeting + status bar
  greeting: 'home-greeting',
  statusBar: 'home-status-bar',
  statusConnectorsStat: 'home-status-connectors-stat',
  statusEventsStat: 'home-status-events-stat',
  statusAlertsStat: 'home-status-alerts-stat',

  // Agent chat hero
  agentHero: 'home-agent-hero',
  agentHeroInput: 'home-agent-hero-input',
  agentHeroSubmitButton: 'home-agent-hero-submit-button',

  // Suggestion pills
  suggestions: 'home-suggestions',
  suggestionPill: (index: number) => `home-suggestion-${index}-pill` as const,

  // Recent Integrations card
  recentIntegrationsCard: 'home-recent-integrations-card',
  recentIntegrationsViewAllButton: 'home-recent-integrations-view-all-button',
  recentIntegrationsEmpty: 'home-recent-integrations-empty',
  recentIntegrationsMetric: 'home-recent-integrations-metric',
  recentIntegrationsList: 'home-recent-integrations-list',
  recentIntegrationsItem: (id: string) => `home-recent-integrations-item-${id}` as const,

  // Needs Attention card
  needsAttentionCard: 'home-needs-attention-card',
  needsAttentionViewActivityButton: 'home-needs-attention-view-activity-button',
  needsAttentionOkMessage: 'home-needs-attention-ok-message',
  needsAttentionFailedSyncsButton: 'home-needs-attention-failed-syncs-button',
  needsAttentionActiveAlertsButton: 'home-needs-attention-active-alerts-button',

  // ── AdminHomePage (admin console home at /admin/) ──────────────────────────
  adminPage: 'admin-home-page',
  adminHeading: 'admin-home-heading',
  adminSubtitle: 'admin-home-subtitle',
  adminStatsGrid: 'admin-home-stats-grid',
  adminStatsLoading: 'admin-home-stats-loading',
  adminStatsEmpty: 'admin-home-stats-empty',
  adminStatCard: (label: string) => `admin-home-stat-${slug(label)}-card` as const,
  adminActivitySection: 'admin-home-activity-section',
  adminActivityList: 'admin-home-activity-list',
  adminActivityEmpty: 'admin-home-activity-empty',
  adminActivityItem: (id: number | string) => `admin-home-activity-item-${id}` as const,
  adminQuickActionsGrid: 'admin-home-quick-actions-grid',
  adminActionButton: (label: string) => `admin-home-action-${slug(label)}-button` as const,
} as const;
